export const gameTitle = "Найди пару";
export const gameRules =
  "Найдите все пары за 2 минуты и получите баллы! Поочередно переворачивайте карточки и запоминайте спрятанные картинки и их расположение на экране.";
export const maxFindPairsTime = 120000;
